import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './App';
import './index.css';

// API 기본 URL 설정
// 개발 환경에서는 proxy 설정 사용, 프로덕션에서는 현재 도메인 사용
const isDevelopment = process.env.NODE_ENV === 'development';
const baseURL = isDevelopment ? '' : window.location.origin;

axios.defaults.baseURL = baseURL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
